import { select } from 'redux-most';
import { switchMap, fromFuture } from 'most-adjunct';
import * as mostc from '../../../crosscutting/mostc';
import * as most from 'most';
import * as r from 'ramda';
import * as signals from '../../signals';
import { change, initialize } from 'redux-form';
import uuid from 'uuid/v4';
import axios from 'axios';

export default function createBootstrapEpic(
  fetchOptsRep,
) {
  return (actions, store) => r.pipe(
    select(signals.BOOTSTRAP),
    switchMap((action) => {
      const state = store.getState();
      const categoryKeyIdMap = state.config.categories;

      const opts = fetchOptsRep(categoryKeyIdMap);

      const showConsent = window.utag.data['cp.pwinteraction'] !== 'yes';

      if(showConsent === true) {
        const source = r.cond([
          [r.has('bannerDomSelector'), r.always('ribbon')],
          [r.has('modalDomSelector'), r.always('modal')],
          [r.T, r.always('unknown')],
        ])(state.config);

        axios({
          method: 'post',
          url: 'https://www.google-analytics.com/collect',
          headers: {
            'Content-Type': 'text/plain',
          },
          data: `v=1&t=event&tid=${CONFIG.analytics.tracker}&cid=${uuid()}&aip=1&ec=Impression&ea=${source}`,
        });
      }

      return r.pipe(
        fromFuture,
        switchMap((options) => {
          return most.from([
            initialize(
              'inlinePrivacy',
              {
                submit: 'accept',
                analytics: options.analytics,
                support: options.support,
                marketing: options.marketing,
              },
            ),
          ]);
        }),
      )(opts);
    }),
  )(actions);
}



// WEBPACK FOOTER //
// ./src/application/epics/privacy/bootstrap.js